import { Theme } from '@mui/material'

export interface C100Tokens {
  accent: string
  gain: string
  loss: string
  flat: string
  page: string
  card: string
  elevated: string
  hairline: string
  text: string
  muted: string
  faintAccentBg: string
}

export function c100Tokens(theme: Theme): C100Tokens {
  const dark = theme.palette.mode === 'dark'
  return dark
    ? {
        accent: '#e25a0b',
        gain: '#4ade80',
        loss: '#f87171',
        flat: '#8b8b92',
        page: '#0d0d0f',
        card: '#161619',
        elevated: '#1c1c20',
        hairline: 'rgba(255,255,255,0.08)',
        text: '#f5f5f5',
        muted: '#8b8b92',
        faintAccentBg: 'rgba(226,90,11,0.12)'
      }
    : {
        accent: '#e25a0b',
        gain: '#16a34a',
        loss: '#dc2626',
        flat: '#8a8a90',
        page: '#faf8f5',
        card: '#ffffff',
        elevated: '#ffffff',
        hairline: 'rgba(0,0,0,0.09)',
        text: '#1a1a1a',
        muted: '#6b6b70',
        faintAccentBg: 'rgba(226,90,11,0.10)'
      }
}

const SECTOR_HUES = [
  '#e25a0b',
  '#3b82f6',
  '#8b5cf6',
  '#ec4899',
  '#14b8a6',
  '#f59e0b',
  '#22c55e',
  '#ef4444',
  '#06b6d4',
  '#a855f7',
  '#eab308',
  '#64748b'
]

export function sectorColor(sector: string): string {
  if (!sector) return '#64748b'
  let h = 0
  for (let i = 0; i < sector.length; i++) h = ((h * 31 + sector.charCodeAt(i)) >>> 0)
  return SECTOR_HUES[h % SECTOR_HUES.length]
}

// Theme-matched thin scrollbar, spreadable into any sx of a scrollable element.
export function scrollbarSx(t: C100Tokens) {
  return {
    scrollbarWidth: 'thin',
    scrollbarColor: `${t.hairline} transparent`,
    '&::-webkit-scrollbar': { width: 8, height: 8 },
    '&::-webkit-scrollbar-track': { background: 'transparent' },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: t.hairline,
      borderRadius: 8,
      border: '2px solid transparent',
      backgroundClip: 'padding-box'
    },
    '&::-webkit-scrollbar-thumb:hover': { backgroundColor: t.muted },
    '&::-webkit-scrollbar-corner': { background: 'transparent' }
  } as const
}
